<template>
  <v-app-bar
    app
    clipped-left
    color="#ffffff"
    class="header elevation-0"
  >
    <v-app-bar-title class="header-title">
      <router-link class="brand" to="/" aria-label="Ir al inicio">
        <span class="brand-mark">f</span><span>fintech<span class="brand-dot">.</span></span>
      </router-link>
    </v-app-bar-title>
    <div class="nav-links d-none d-md-flex">
      <router-link to="/explorar">Oportunidades</router-link>
      <a href="/#how-it-works">Cómo funciona</a>
      <router-link to="/market">Mercado</router-link>
    </div>
    <v-spacer></v-spacer>
    <AccountMenu/>
  </v-app-bar>
</template>

<script>
import AccountMenu from './AccountMenu';

export default {
  name: 'Header',
  components: {
    AccountMenu
  }
}
</script>

<style>

.header { font-family: Inter, Arial, sans-serif; border-bottom: 1px solid #e8e5df!important; padding:0 3.4vw!important; color:#173347!important; }
.header-title { font-size:1.25rem; }
.brand { display:inline-flex;align-items:center;color:#173347!important;font-size:21px!important;font-weight:800!important;letter-spacing:-1px!important;text-transform:none!important;text-decoration:none;padding:8px 0; }
.brand-mark{display:inline-flex;width:25px;height:25px;border-radius:50%;align-items:center;justify-content:center;background:#e76f51;color:#fff;font-family:Georgia,serif;font-weight:400;margin-right:7px;font-size:19px}.brand-dot{color:#e76f51}.nav-links{gap:30px;margin-left:65px}.nav-links a{font-size:12px;font-weight:700;color:#426070;text-decoration:none}.nav-links a:hover{color:#e76f51}

</style>
